export enum AuthzEntityType {
    Pipeline = 'pipeline',
    Asset = 'asset',
}
